module.exports = __webpack_public_path__ + "static/media/64.3447dd04.png";